<script>export let src;
export let alt = null;
export let classNames = null;
export let isLazyLoaded = true;
</script>

{#if src}
	{#if typeof src == 'string'}
		<img {src} {alt} class={classNames} loading={isLazyLoaded ? 'lazy' : 'eager'} />
	{:else}
		<picture>
			{#if src.sources}
				{#each src.sources as source}
					<source
						type={source.type}
						media={source.media}
						srcset={source.srcset}
						sizes={source.sizes}
						width={source.width}
						height={source.height}
					/>
				{/each}
			{/if}

			<img
				src={src.img}
				alt={alt ?? src.alt}
				class={classNames}
				loading={isLazyLoaded ? 'lazy' : 'eager'}
				width={src.width}
				height={src.height}
				fetchpriority={src.fetchpriority}
			/>
		</picture>
	{/if}
{/if}
